import {createContext, FC, useContext, useState} from 'react'
import {WithChildren} from '@/_metronic/helpers'
import {BaseRequest} from '@/_metronic/helpers/crud-helper/base-request'
import { FilterWalletHistory, initialFilterWalletHistory } from './_models'

type SubscriptionHistoryQueryRequestContextProps = {
  state: BaseRequest<FilterWalletHistory>
  updateState: (updates: Partial<BaseRequest<FilterWalletHistory>>) => void
}

const initialQueryRequest = {
  state: initialFilterWalletHistory,
  updateState: () => {},
}

const QueryRequestContext = createContext<SubscriptionHistoryQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<BaseRequest<FilterWalletHistory>>(initialQueryRequest.state)

  const updateState = (updates: Partial<BaseRequest<FilterWalletHistory>>) => {
    const updatedState = {...state, ...updates} as BaseRequest<FilterWalletHistory>
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
